export const SET_IS_FETCHING = 'dashboard/DeviceManagement/SET_IS_FETCHING'
export const DEVICES_DATA_RECEIVED = 'dashboard/DeviceManagement/DEVICES_DATA_RECEIVED'
export const DEVICES_PAGING_RECEIVED = 'dashboard/DeviceManagement/DEVICES_PAGING_RECEIVED'
export const DEVICE_DATA_RECEIVED = 'dashboard/DeviceManagement/DEVICE_DATA_RECEIVED'
export const SET_QUERY_FILTER = 'dashboard/DeviceManagement/SET_QUERY_FILTER'
